


const buttons = document.querySelectorAll('.user-type__button');
const popup = document.querySelector('.user-type__popup');
const items = document.querySelectorAll('.user-type__item');
const intros = document.querySelectorAll('.user-type__intro');
const buttonGroups = document.querySelectorAll('.user-type__buttons');
const pages = document.querySelectorAll('.user-type__pages');



export default function setupUserTypes() {

    if ( !buttons || !popup || !items ) return;

    // Close popup when user clicks outside popup
    document.addEventListener('click', (evt) => {
        if ( !popup.contains(evt.target) && ![...buttons].some(btn => btn === evt.target) ) {
            popup.classList.remove('open');
            buttons.forEach(button => button.classList.remove('active'));
        }
    });

    buttons.forEach((button) => {
        // Open popup on button press
        button.addEventListener('click', () => {
            buttons.forEach(button => button.style.anchorName  = 'none');
            button.style.anchorName  = '--user-type';
            popup.classList.toggle('open');
            button.classList.toggle('active');
        });
    });

    items.forEach(
        item => item.addEventListener('click', () => {
            items.forEach(i => i.removeAttribute('data-current'));
            item.setAttribute('data-current', 'true');
            buttons.forEach(button => {
                button.innerHTML = item.textContent;
            });

            activate(intros, item.dataset.slug);
            activate(buttonGroups, item.dataset.slug);
            activate(pages, item.dataset.slug);

            // Defer slide update until the active-item CSS transition has finished,
            // so Splide DOM mutations don't cause layout invalidation mid-animation.
            const slug = item.dataset.slug;
            let ran = false;
            const run = () => { if (!ran) { ran = true; activateSlideCategories(slug); } };
            item.addEventListener('transitionend', run, { once: true });
            // Fallback: if there is no transition (or it never fires), run after 500 ms.
            setTimeout(run, 300);
        })
    );
}



function activate (elements, category = 'all') {
    if ( !elements ) return;

    elements.forEach(intro => {
        if ( intro.dataset.category === category ) {
            intro.classList.add('active');
        } else {
            intro.classList.remove('active');
        }
    });
}



export function activateSlideCategories (category = null) {
    const slides = window.splide.Components.Slides.get();
    if ( !slides ) return;

    // Add all slides
    window.initialSlides
        .forEach( (initialSlide) => {
            const slideAlreadyInSlider = slides.some(slideComponent => {
                return slideComponent.slide.dataset.id === initialSlide.slide.dataset.id;
            });

            if ( !slideAlreadyInSlider ) {
                window.splide.add(initialSlide.slide);
            }
        });

    // Remove slides not in category
    if ( category ) {
        slides
            .forEach(slide => {
                if ( !slide.slide.dataset.categories.includes(category) ) {
                    window.splide.remove(slide.slideIndex);
                }
            });
    }
}
